import React from "react";
import styles from "@/styles/detail/DetailBookingSidebar/AccordionItemActivity.module.scss";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";

export interface AccordionItemProps {
    title: string;
    extraTitle?: React.ReactNode;
    showDivider?: boolean;
    classNameHeader?: string;
    isOpen?: boolean;
    onItemClick?: () => void;
    children: React.ReactNode;
}

const AccordionItemActivity: React.FC<AccordionItemProps> = ({
    title,
    extraTitle,
    children,
    isOpen,
    onItemClick,
    showDivider = true,
    classNameHeader = "",
}) => {
    const { ArrowUpSimpleLine } = userInterfaceSvg;

    const handleItemClick = () => {
        if (onItemClick) {
            onItemClick();
        }
    };

    return (
        <div
            className={`${styles.accordionItem} ${
                isOpen && styles.accordionItemOpen
            }`}
        >
            <div
                className={`${styles.accordionItemHeader} ${classNameHeader} ${
                    isOpen ? styles.accordionItemHeaderOpen : ""
                }
                ${
                    isOpen && showDivider
                        ? styles.accordionItemHeaderOpenDivider
                        : ""
                }
                `}
                onClick={handleItemClick}
            >
                {extraTitle && <div className="me-3">{extraTitle}</div>}
                <h3 className="me-auto">{title}</h3>

                <div
                    className={
                        isOpen
                            ? styles.accordionItemHeaderIcon
                            : styles.accordionItemHeaderIconOpen
                    }
                >
                    <ArrowUpSimpleLine />
                </div>
            </div>
            {isOpen && (
                <div className={styles.accordionItemContent}>{children}</div>
            )}
        </div>
    );
};

export default AccordionItemActivity;
